module.exports = {
  src: __webpack_public_path__ + "assets/images/video_version-placeholder.a2b7f4d3ea4bdfc6.png",
  width: 1558,
  height: 953,
  toString: function() { return __webpack_public_path__ + "assets/images/video_version-placeholder.a2b7f4d3ea4bdfc6.png"; }
};